/** Enter в поле ввода → фокус на следующее поле (формы и модалки CRM). */

import { isPhoneField } from './phoneField';

const SKIP_INPUT_TYPES = new Set([
  'hidden',
  'button',
  'submit',
  'reset',
  'checkbox',
  'radio',
  'file',
  'image',
  'color',
]);

function isVisible(el) {
  if (!(el instanceof HTMLElement)) return false;
  if (el.disabled) return false;
  const style = window.getComputedStyle(el);
  if (style.display === 'none' || style.visibility === 'hidden') return false;
  return el.getClientRects().length > 0;
}

export function isEnterNavField(el) {
  if (!(el instanceof HTMLElement)) return false;
  if (!isVisible(el)) return false;
  if (el.closest('[data-no-enter-nav]')) return false;
  if (el.closest('[data-skip-enter-nav]')) return false;

  if (el instanceof HTMLTextAreaElement) return false;

  if (el instanceof HTMLSelectElement) return true;

  if (el instanceof HTMLInputElement) {
    if (el.readOnly) return false;
    const type = (el.type || 'text').toLowerCase();
    if (SKIP_INPUT_TYPES.has(type)) return false;
    if (type === 'number') return false;
    const mode = (el.inputMode || el.getAttribute('inputmode') || '').toLowerCase();
    if (mode === 'decimal' || mode === 'numeric') return false;
    if (el.closest('[data-money-input], [data-no-enter-nav]')) return false;
    return true;
  }

  if (el.isContentEditable) return false;

  return false;
}

function findContainer(el) {
  return el.closest(
    'form, [data-enter-nav], [role="dialog"], .chakra-modal__content, main, [role="main"]'
  );
}

function getEnterNavFields(container) {
  const nodes = container.querySelectorAll('input, select, textarea');
  return Array.from(nodes).filter(isEnterNavField);
}

function scrollIntoModalView(el) {
  // Прокручиваем ближайший скролл-контейнер модалки (не страницу целиком).
  const scrollContainer = el.closest(
    '[data-modal-scroll-body], .chakra-modal__body, [role="dialog"]'
  );
  if (!scrollContainer) {
    el.scrollIntoView?.({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    return;
  }
  const containerRect = scrollContainer.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();
  const overBottom = elRect.bottom - (containerRect.bottom - 16);
  const overTop = containerRect.top + 16 - elRect.top;
  if (overBottom > 0) {
    scrollContainer.scrollTop += overBottom;
  } else if (overTop > 0) {
    scrollContainer.scrollTop -= overTop;
  }
}

function focusField(el) {
  el.focus({ preventScroll: true });
  // Для текстовых полей выделяем всё содержимое (кроме tel — там нормализованный номер).
  if (el instanceof HTMLInputElement && typeof el.select === 'function') {
    const type = (el.type || 'text').toLowerCase();
    if (type === 'text' || type === 'search' || type === 'url') {
      try {
        el.select();
      } catch {
        /* ignore */
      }
    }
  }
  // После фокуса прокручиваем к элементу внутри модалки (preventScroll выше это подавил).
  requestAnimationFrame(() => scrollIntoModalView(el));
}

function handleEnterNavigation(e) {
  if (e.key !== 'Enter' || e.defaultPrevented) return;
  if (e.shiftKey || e.ctrlKey || e.metaKey || e.altKey) return;

  const target = e.target;
  if (isPhoneField(target)) return;
  if (!isEnterNavField(target)) return;

  const container = findContainer(target);
  if (!container) return;

  const fields = getEnterNavFields(container);
  const index = fields.indexOf(target);
  if (index < 0 || index >= fields.length - 1) return;

  e.preventDefault();
  e.stopPropagation();
  focusField(fields[index + 1]);
}

export function initFormEnterNavigation() {
  window.addEventListener('keydown', handleEnterNavigation, true);
  return () => window.removeEventListener('keydown', handleEnterNavigation, true);
}
